'use client';
import styled from 'styled-components';

import { LANDING_BREAKPOINT } from '@utils/theme/breakPoint';

export const Container = styled.div`
  position: relative;
  height: 100vh;

  /* we need this for really small devices */
  @media (max-width: 350px) {
    margin-bottom: 100px;
  }
`;

export const ErrorPageHeaderWrapper = styled.div`
  position: sticky;
  top: 0;
  z-index: 20;
  width: 100%;
`;

export const BookerContainer = styled.div`
  position: absolute;
  top: 140px;
  left: 100px;

  @media (max-width: ${LANDING_BREAKPOINT}) {
    position: absolute;
    width: 100%;
    left: unset;
    top: 20px;
  }
`;

export const ErrorContainer = styled.div`
  position: absolute;
  top: 286px;
  left: 766px;
  z-index: 1;
  width: 433px;
  height: 199px;

  @media (max-width: ${LANDING_BREAKPOINT}) {
    top: 80px;
    left: 50%;
    margin-left: -108.5px;
    width: 217px;
    height: 90px;
  }
`;
export const ErrorContainer503 = styled.div`
  position: absolute;
  top: 200px;
  left: 500px;
  z-index: 1;
  width: 433px;
  height: 199px;
  @media (max-width: ${LANDING_BREAKPOINT}) {
    top: 95.5px;
    left: 50%;
    margin-left: -108.5px;
    width: 217px;
    height: 90px;
  }
`;

export const ErrorImageContainer = styled.div`
  position: relative;
  left: 96px;
  width: 241px;
  height: 108.5px;
  @media (max-width: ${LANDING_BREAKPOINT}) {
    left: 48px;
    width: 120px;
    height: 54px;
  }
`;

export const ErrorTextContainer = styled.div`
  margin-top: 32px;
  width: 433px;
  height: 54px;
  text-align: center;
  font-weight: 600;
  font-size: 21.6px;
  color: ${({ theme }) => `${theme.palette.darkGray}`};
  @media (max-width: ${LANDING_BREAKPOINT}) {
    margin-top: 6px;
    width: 217px;
    height: 28px;
    font-size: 10.8px;
  }
`;

export const HeroImageContainer = styled.div`
  z-index: -1;
  @media (max-width: ${LANDING_BREAKPOINT}) {
    position: relative;
    width: 100vw;
    height: 100%;
    top: 0;
    left: 0;
  }
`;
